<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="eventAgendaForm" v-model="formValid" validate-on="input">
        <v-container>
          <v-row class="pa-2">
            <v-col cols="12">
              <h4 class="text-h6">Agenda</h4>
            </v-col>
            <v-col cols="12">
              <v-card class="pa-4 mb-4 mx-auto" v-for="(schedule, index) in schedules" rounded="xl" :key="schedule.id">
                <div class="d-flex justify-space-between">
                  <h2 class="mb-2">{{ index + 1 }}. Tag {{ schedule.name }}</h2>
                  <v-tooltip location="bottom" offset-y>
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" density="compact" absolute location="top right"  icon variant="text" color="white" class="bg-error" @click="removeScheduleDay(schedule.id)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Entfernen</span>
                </v-tooltip>
                </div>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      variant="filled"
                      v-model="schedule.date"
                      bg-color="accent"
                      label="Datum"
                      type="date"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      variant="filled"
                      v-model="schedule.time"
                      bg-color="accent"
                      label="Uhrzeit"
                      type="time"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      variant="filled"
                      v-model="schedule.description"
                      bg-color="accent"
                      label="Beschreibung"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center" v-for="(s, index) in schedule.schedules" :key="index">
                  <v-col cols="4">
                    <v-text-field
                      variant="filled"
                      v-model="s.time"
                      bg-color="accent"
                      label="Uhrzeit"
                      hide-details
                      type="time"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="7">
                    <v-text-field
                      variant="filled"
                      v-model="s.description"
                      bg-color="accent"
                      label="Beschreibung"
                      hide-details
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <v-tooltip location="bottom" offset-y>
                      <template v-slot:activator="{ props }">
                        <v-btn icon variant="text" v-bind="props"><v-icon color="red" @click="removeScheduleFromDay({dayId: schedule.id, id: s.id})">mdi-delete</v-icon></v-btn>
                      </template>
                        <span>Programmpunkt entfernen</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-tooltip location="bottom" offset-y>
                      <template v-slot:activator="{ props }">
                        <v-btn class="bg-primary" color="white" v-bind="props" size="small" icon variant="text" @click="addNewScheduleForDay(schedule.id)">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Programmpunkt hinzufügen</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
              <v-col cols="12" class="d-flex align-center justify-center">
                <v-tooltip location="bottom" offset-y>
                  <template v-slot:activator="{ props }">
                    <v-btn class="bg-primary align-center" color="white" v-bind="props" size="large" icon variant="text" @click="addNewScheduleDay">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Zeitplanung hinzufügen</span>
                </v-tooltip>
              </v-col>
            </v-col>
          </v-row>
        </v-container>
        <Pager :invalid="false"/>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Pager from "@/components/Events/Form/Pager";
import uniqueId from "lodash/uniqueId";

export default {
  components: {
    Pager,
  },
  data(){
    return {
      formValid: false
    }
  },
  methods: {
    ...mapActions({
      updateValue: "events/updateForm",
      addScheduleDay: "events/addScheduleDay",
      removeScheduleDay: "events/removeScheduleDay",
      addScheduleForDay: "events/addScheduleForDay",
      removeScheduleFromDay: "events/removeScheduleFromDay",
    }),
    addNewScheduleDay() {
      this.addScheduleDay({
        id: uniqueId(),
        date: "",
        time: "",
        description: "",
        schedules: [],
      })
    },
    addNewScheduleForDay(dayId) {
      this.addScheduleForDay({
        dayId,
        id: uniqueId(),
        time: "",
        description: "",
      })
    },
  },
  computed: {
    ...mapGetters({
      schedules: "events/schedules",
    }),
    schedule: {
      get() {
        return this.$store.state.events.form.schedule
      },
      set(value) {
        this.updateValue({ parent: null, field: "schedule", value: value });
      }
    },
  },
}
</script>

<style scoped>

</style>
